import pic1  from './1.png';
import pic2  from './2.png';
import pic3  from './3.png';
import pic4  from './4.png';
import pic5  from './5.png';
import pic6  from './6.png';
import pic7  from './7.png';
import pic8  from './8.png';
import pic9  from './9.png';
import pic10 from './10.png';
import pic11 from './11.png';
import pic12 from './12.png';
import pic13 from './13.png';
import pic14 from './14.png';
import pic15 from './15.png';
import pic16 from './16.png';
import pic17 from './17.png';
import pic18 from './18.png';
import pic19 from './19.png';
import pic20 from './20.png';
import pic21 from './21.png';
import pic22 from './22.png';
import pic23 from './23.png';
import pic24 from './24.png';
import pic25 from './25.png';
import pic26 from './26.png';
import pic27 from './27.png';
import pic28 from './28.png';
import pic29 from './29.png';
import pic30 from './30.png';
import pic31 from './31.png';
import pic32 from './32.png';
import pic33 from './33.png';
import pic34 from './34.png';
import pic35 from './35.png';
import pic36 from './36.png';
import pic37 from './37.png';
import pic38 from './38.png';
import pic39 from './39.png';
import pic40 from './40.png';
import pic41 from './41.png';
import pic42 from './42.png';
import pic43 from './43.png';
import pic44 from './44.png';
import pic45 from './45.png';
import pic46 from './46.png';
import pic47 from './47.png';
import pic48 from './48.png';
import pic49 from './49.png';
import pic50 from './50.png';
import pic51 from './51.png';
import pic52 from './52.png';
import pic53 from './53.png';
import pic54 from './54.png';
import pic55 from './55.png';
import pic56 from './56.png';
import pic57 from './57.png';
import pic58 from './58.png';
import pic59 from './59.png';
import pic60 from './60.png';
import pic61 from './61.png';
import pic62 from './62.png';
import pic63 from './63.png';
import pic64 from './64.png';
import pic65 from './65.png';
import pic66 from './66.png';

export default [
    { name: "Trust",  pic: pic1  },
    { name: "Blockchain",  pic: pic2  },
    { name: "Binance Smart Chain",  pic: pic3  },
    { name: "Metamask",  pic: pic4  },
    { name: "Coinomi",  pic: pic5  },
    { name: "Argent",  pic: pic6  },
    { name: "Rainbow",  pic: pic7  },
    { name: "Crypto.com | DeFi Wallet",  pic: pic8  },
    { name: "Pillar",  pic: pic9  },
    { name: "imToken",  pic: pic10 },
    { name: "Anchor",  pic: pic11 },
    { name: "ONTO",  pic: pic12 },
    { name: "TokenPocket",  pic: pic13 },
    { name: "BitPay",  pic: pic14 },
    { name: "Maiar",  pic: pic15 },
    { name: "Ledger Live",  pic: pic16 },
    { name: "Walleth",  pic: pic17 },
    { name: "Authereum",  pic: pic18 },
    { name: "Huobi Wallet",  pic: pic19 },
    { name: "Eidoo",  pic: pic20 },
    { name: "Loopring Wallet",  pic: pic21 },
    { name: "TrustVault",  pic: pic22 },
    { name: "Atomic",  pic: pic23 },
    { name: "CoolWallet S",  pic: pic24 },
    { name: "Alice",  pic: pic25 },
    { name: "AlphaWallet",  pic: pic26 },
    { name: "D'CENT Wallet",  pic: pic27 },
    { name: "ZelCore",  pic: pic28 },
    { name: "Nash",  pic: pic29 },
    { name: "GridPlus",  pic: pic30 },
    { name: "CYBAVO Wallet",  pic: pic31 },
    { name: "Tokenary",  pic: pic32 },
    { name: "Wazirx",  pic: pic33 },
    { name: "Torus",  pic: pic34 },
    { name: "Spatium",  pic: pic35 },
    { name: "SafePal",  pic: pic36 },
    { name: "Equal",  pic: pic37 },
    { name: "Infinito",  pic: pic38 },
    { name: "wallet.io",  pic: pic39 },
    { name: "Infinity Wallet",  pic: pic40 },
    { name: "Ownbit",  pic: pic41 },
    { name: "EasyPocket",  pic: pic42 },
    { name: "Bridge Wallet",  pic: pic43 },
    { name: "SparkPoint",  pic: pic44 },
    { name: "ViaWallet",  pic: pic45 },
    { name: "BitKeep",  pic: pic46 },
    { name: "Vision",  pic: pic47 },
    { name: "SWFT Wallet",  pic: pic48 },
    { name: "PEAKDEFI Wallet",  pic: pic49 },
    { name: "Cosmostation",  pic: pic50 },
    { name: "Graph Protocol",  pic: pic51 },
    { name: "KardiaChain",  pic: pic52 },
    { name: "Keplr",  pic: pic53 },
    { name: "Harmony",  pic: pic54 },
    { name: "ICONex",  pic: pic55 },
    { name: "Fetch",  pic: pic56 },
    { name: "XDC Wallet",  pic: pic57 },
    { name: "Unstoppable Wallet",  pic: pic58 },
    { name: "MEET.ONE",  pic: pic59 },
    { name: "Dok Wallet",  pic: pic60 },
    { name: "AT.Wallet",  pic: pic61 },
    { name: "MoriX Wallet",  pic: pic62 },
    { name: "Midas Wallet",  pic: pic63 },
    { name: "Ellipal",  pic: pic64 },
    { name: "KEYRING PRO",  pic: pic65 },
    { name: "Aktionariat",  pic: pic66 }
];